var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.noneChildPage ? [_c('div', {
    staticClass: "sub-content"
  }), _vm._v(" "), _c('div', {
    staticClass: "airgsm-container mb-5",
    attrs: {
      "dir": "auto"
    }
  }, [_c('div', {
    staticClass: "campaign-container padd-top-0 mobile-relative"
  }, [_c('nuxt-child')], 1)])] : [_c('nuxt-child')]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }